import React from "react";

function Template9() {
  const mockData = {
    podcast: {
      pagetitle: "AI Podcast: Automated Lesson Recaps",
      content1:
        "AristAI's AI Podcast feature transforms course materials into short, personalized audio summaries that reinforce learning and increase student engagement outside the classroom.",
      content2:
        "By generating concise, voice-based recaps from lectures, notes, or instructor-provided content, the AI Podcast helps students review key concepts anytime, anywhere.",
      section1: {
        subsection1: "Automated Audio Summaries",
        subsection2:
          "The system uses AI to extract core concepts from slides, documents, or discussions and converts them into coherent, student-friendly podcast episodes.",
        subsection3:
          "This allows students to passively review material during daily routines—boosting retention and accessibility.",
      },
      section2: {
        subsection1: "Instructor Customization and Review",
        subsection2:
          "Educators can review, edit, or approve episodes before release, ensuring academic accuracy and tone consistency.",
        subsection3:
          "The system supports multiple languages and can be adapted for different subjects or learning levels.",
      },
      section3: {
        subsection1: "Integrated Learning Experience",
        subsection2:
          "The AI Podcast works alongside the AI Tutor, offering students both interactive support and passive review tools within the same platform.",
        subsection3:
          "Together, they create a more holistic and flexible learning environment tailored to modern learners.",
      },
    },
  };


  const handleGoBack = () => {
    window.location.href = "/";
  };

  return (
    <div style={{ ...styles.container, ...styles.fadeIn }}>
      <button onClick={handleGoBack} style={styles.closeButton} aria-label="Close and return to home">
        ✕
      </button>
      {/* Left Section */}
      <div style={styles.leftSection}>
        <h1 style={styles.mainTitle}>{mockData.podcast.pagetitle}</h1>
        <p style={styles.description}>{mockData.podcast.content1}</p>
        <p style={styles.description}>{mockData.podcast.content2}</p>
        <img src="https://d2hp1ftv5ri2om.cloudfront.net/assets/landing/podcast.png" alt="AristAI Logo" style={{
          width: "100%",
          maxWidth: "300px",
          marginTop: "2rem",
          borderRadius: "8px",
        }} />
      </div>

      {/* Right Section */}
      <div style={styles.rightSection}>
        <div style={styles.contentBox}>
          <div style={styles.iconBox}></div>
          <div style={styles.textContent}>
            <h2 style={styles.heading}>{mockData.podcast.section1.subsection1}</h2>
            <p style={styles.text}>{mockData.podcast.section1.subsection2}</p>
            <p style={styles.text}>{mockData.podcast.section1.subsection3}</p>
          </div>
        </div>

        <div style={styles.contentBox}>
          <div style={styles.iconBox}></div>
          <div style={styles.textContent}>
            <h2 style={styles.heading}>{mockData.podcast.section2.subsection1}</h2>
            <p style={styles.text}>{mockData.podcast.section2.subsection2}</p>
            <p style={styles.text}>{mockData.podcast.section2.subsection3}</p>
          </div>
        </div>

        <div style={styles.contentBox}>
          <div style={styles.iconBox}></div>
          <div style={styles.textContent}>
            <h2 style={styles.heading}>{mockData.podcast.section3.subsection1}</h2>
            <p style={styles.text}>{mockData.podcast.section3.subsection2}</p>
            <p style={styles.text}>{mockData.podcast.section3.subsection3}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: "flex",
    backgroundColor: "#000",
    color: "#fff",
    minHeight: "100vh",
    padding: "3rem",
    gap: "4rem",
    margin: "0 auto",
    position: "absolute",
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
  },
  fadeIn: {
    animation: "fadeInFromLeft 0.8s ease-out forwards",
    opacity: 0,
  },
  leftSection: {
    flex: "1",
    paddingTop: "2rem",
  },
  rightSection: {
    flex: "1",
    display: "flex",
    flexDirection: "column",
    gap: "2rem",
    paddingTop: "4rem",
  },
  mainTitle: {
    fontSize: "3.5rem",
    fontWeight: "bold",
    marginBottom: "2rem",
    lineHeight: "1.2",
  },
  description: {
    fontSize: "1.1rem",
    lineHeight: "1.6",
    color: "#999",
    marginBottom: "1rem",
  },
  contentBox: {
    display: "flex",
    gap: "1.5rem",
    alignItems: "flex-start",
  },
  iconBox: {
    width: "48px",
    height: "48px",
    backgroundColor: "#333",
    borderRadius: "8px",
    flexShrink: 0,
  },
  textContent: {
    flex: "1",
  },
  heading: {
    fontSize: "1.25rem",
    fontWeight: "bold",
    marginBottom: "0.5rem",
    marginTop: "0",
  },
  text: {
    fontSize: "1rem",
    lineHeight: "1.6",
    color: "#999",
  },
  closeButton: {
    position: "absolute",
    top: "20px",
    right: "20px",
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    backgroundColor: "transparent",
    border: "1px solid #fff",
    color: "#fff",
    fontSize: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    transition: "all 0.3s ease",
    zIndex: 10,
  },
};

// Add the keyframes animation to the document
const styleSheet = document.createElement("style");
styleSheet.textContent = `
  @keyframes fadeInFromLeft {
    from {
      opacity: 0;
      transform: translateX(-50px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }
`;
document.head.appendChild(styleSheet);

export default Template9;
